import {
  FETCH_UGC_ASSETS_START,
  FETCH_UGC_ASSETS_SUCCESS,
  FETCH_UGC_ASSETS_ERROR,
  CREATE_UGC_ASSET_START,
  CREATE_UGC_ASSET_SUCCESS,
  CREATE_UGC_ASSET_ERROR,
  UPDATE_UGC_ASSET_START,
  UPDATE_UGC_ASSET_SUCCESS,
  UPDATE_UGC_ASSET_ERROR,
  DELETE_UGC_ASSET_START,
  DELETE_UGC_ASSET_SUCCESS,
  DELETE_UGC_ASSET_ERROR,
  IMPORT_UGC_ASSETS_START,
  IMPORT_UGC_ASSETS_SUCCESS,
  IMPORT_UGC_ASSETS_ERROR,
  LOG_UGC_REUSE_START,
  LOG_UGC_REUSE_SUCCESS,
  LOG_UGC_REUSE_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  ugcAssets: [],
  stats: {
    total_assets: 0,
    video_count: 0,
    image_count: 0,
    active_licenses: 0,
    total_reuses: 0,
  },
  categories: [],
  mediaTypes: [],
  licenseTypes: [],
  rightsDurations: [],

  loading: false,
  error: null,

  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  importLoading: false,
  logReuseLoading: false,
}

const ugcReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_UGC_ASSETS_START:
      return { ...state, loading: true, error: null }
    case FETCH_UGC_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        ugcAssets: action.payload.ugc_assets,
        stats: action.payload.stats,
        categories: action.payload.categories,
        mediaTypes: action.payload.media_types,
        licenseTypes: action.payload.license_types,
        rightsDurations: action.payload.rights_durations,
      }
    case FETCH_UGC_ASSETS_ERROR:
      return { ...state, loading: false, error: action.payload }

    case CREATE_UGC_ASSET_START:
      return { ...state, createLoading: true }
    case CREATE_UGC_ASSET_SUCCESS:
      return {
        ...state,
        createLoading: false,
        ugcAssets: [action.payload, ...state.ugcAssets],
        stats: {
          ...state.stats,
          total_assets: state.stats.total_assets + 1,
        },
      }
    case CREATE_UGC_ASSET_ERROR:
      return { ...state, createLoading: false }

    case UPDATE_UGC_ASSET_START:
      return { ...state, updateLoading: true }
    case UPDATE_UGC_ASSET_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        ugcAssets: state.ugcAssets.map((a) => (a.id === action.payload.id ? action.payload : a)),
      }
    case UPDATE_UGC_ASSET_ERROR:
      return { ...state, updateLoading: false }

    case DELETE_UGC_ASSET_START:
      return { ...state, deleteLoading: true }
    case DELETE_UGC_ASSET_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        ugcAssets: state.ugcAssets.filter((a) => a.id !== action.payload),
        stats: {
          ...state.stats,
          total_assets: Math.max(0, state.stats.total_assets - 1),
        },
      }
    case DELETE_UGC_ASSET_ERROR:
      return { ...state, deleteLoading: false }

    case IMPORT_UGC_ASSETS_START:
      return { ...state, importLoading: true }
    case IMPORT_UGC_ASSETS_SUCCESS:
      return {
        ...state,
        importLoading: false,
        ugcAssets: [...action.payload, ...state.ugcAssets],
        stats: {
          ...state.stats,
          total_assets: state.stats.total_assets + action.payload.length,
        },
      }
    case IMPORT_UGC_ASSETS_ERROR:
      return { ...state, importLoading: false }

    case LOG_UGC_REUSE_START:
      return { ...state, logReuseLoading: true }
    case LOG_UGC_REUSE_SUCCESS:
      return {
        ...state,
        logReuseLoading: false,
        ugcAssets: state.ugcAssets.map((a) => (a.id === action.payload.id ? action.payload : a)),
        stats: {
          ...state.stats,
          total_reuses: state.stats.total_reuses + 1,
        },
      }
    case LOG_UGC_REUSE_ERROR:
      return { ...state, logReuseLoading: false }

    default:
      return state
  }
}

export default ugcReducer
